// extracted by mini-css-extract-plugin
export var wordContainer = "_qm-0";